
export default {

    setViewRequestsData (state, data) {
      state.attestationAccounts = data
    },
    clearViewRequestData: (state) => {
      state.onboardingAccounts = []
    },
    setLoadingRequest: (state, loading) => {
      state.loadingRequest = loading
    },

    setUpdatingRequest: (state, loading) => {
      state.updatingRequest = loading
    },

    setRequestDetail: (state, data) => {
      state.request = {
        ...data
      }
    },

    updateOnboardingContacts (state) {
     
      state.updateAccount.record.Notification_List = state.updateAccount.Notification_List ? JSON.stringify(state.updateAccount.Notification_List.map(record => record)) : '[]'
      state.updateAccount.record.IAM_Users = state.updateAccount.IAM_Users ? JSON.stringify(state.updateAccount.IAM_Users.map(record => record)) : '[]'
      state.updateAccount.record.Financial_Owner = state.updateAccount.Financial_Owner ? JSON.stringify(state.updateAccount.Financial_Owner.map(record => record)) : '[]'
    },
    updateContactEmails: (state, account) => {
      console.log('============================')
      console.log(typeof(account.IAM_Users))
      console.log(account.IAM_Users)
      console.log('============================')
      state.updateAccount.IAM_Users = JSON.parse(account.IAM_Users)
      state.updateAccount.Notification_List = JSON.parse(account.Notification_List)
      state.updateAccount.Financial_Owner = JSON.parse(account.Financial_Owner)
    },
    showUpdateDialog: (state, account) => {
      state.updateAccount.showDialog = true
      state.showStatuses = { Workload_Status: account.Workload_Status, AWS_Support_Type: account.AWS_Support_Type, WS_Selected: account.WS_Selected }
      if(account.Acct_DL === "None"){
        account.Acct_DL = ""
      }
      console.log('---------- iamusers ------------')
      console.log(typeof (account.IAM_Users))
      console.log('--------------------------------')
    
      state.updateAccount.record = {
        Onboarding_Id: account.Onboarding_Id,
        Acct_name: account.Acct_name,
        Acct_Description: account.Acct_Description,
        Requestor_FullName: account.Requestor_FullName,
        Date_Requested: account.Date_Requested,
        Managed_Svc: account.Managed_Svc,
        Calculated_Master_Payer: account.Calculated_Master_Payer,
        Acct_DL: account.Acct_DL,
        Acct_ID: account.Acct_ID,
        Acct_Alias_Group:account.Acct_Alias_Group,
        OppReg_Id: account.OppReg_Id,
        Onboarding_Status: account.Onboarding_Status,
        Date_onboarded: account.Date_onboarded,
        Acct_Restricted: account.Acct_Restricted,
        Financial_Id: account.Financial_Id,
        Business_Use: account.Business_Use,
        Customer_Name: account.Customer_Name,
        Customer_Id: account.Customer_Id,
        AWS_credits: account.AWS_credits,
        WBS_code: account.WBS_code,
        IWO_Code: account.IWO_Code,
        Request_Type: account.Request_Type,
        SaaS: account.SaaS,
        MFA: account.MFA,
        Root_Credential_Store: account.Root_Credential_Store,
        Specific_Location: account.Specific_Location,
        Specific_Region: account.Specific_Region,
        Engr_Assigned_To: account.Engr_Assigned_To,
        OBS_Date_Updated: account.OBS_Date_Updated,
        Tmp_Cust_Name: account.Tmp_Cust_Name, 
        AWS_Req_Type: account.AWS_Req_Type,
        // Need to determine if Master_Id  and MP_ID 
        // Master_ID: account.MP_ID,
        MP_ID: account.MP_ID, 
        AcctSecurity_Id: account.AcctSecurity_Id,
        Unique_Agreement_Id: account.Unique_Agreement_Id,
        Acct_Exp_Id: account.Acct_Exp_Id,
        Registration_Id: account.Registration_Id,
        Account_Owners: account.Account_Owners,
        CloudCheckr_users: account.CLoudCheckr_users,
        IAM_Users: account.IAM_Users,
        Notification_List: account.Notification_List,
        Financial_Owner: account.Financial_Owner,
        Acct_DL: account.Acct_DL,
        // Opportunity_Number: account.Opportunity_Number
        // WS_Selected: account.WS_Selected
      }
    },
    clearUpdateDialog: (state) => {
      state.updateAccount = {
        accountId: '',
        accountIdExistError: false,
        accountIdExistErrorMessages: [],
        accountIdExistSuccess: false,
        accountIdExistSuccessMessages: [],
        accountIdExistLoading: false,
  
        opportunityNumber: '',
        opportunityNumberExistError: false,
        opportunityNumberExistErrorMessages: [],
        opportunityNumberExistSuccess: false,
        opportunityNumberExistSuccessMessages: [],
        opportunityNumberExistLoading: false,
  
        searching: false,
        saving: null,
        showAlertResponse: false,
        alertType: null, // ie: error or success
        alertMessage: null,
        showDialog: false,
        IAM_Users:[],
        Notification_List: [],
        Financial_Owner:[],
        record: {
          Onboarding_Id: null,
          Acct_name: null,
          Acct_Description: null,
          Requestor_FullName: null,
          Date_Requested: null,
          Managed_Svc: null,
          Calculated_Master_Payer: null,
          Acct_DL: null,
          Acct_ID: null,
          Acct_Alias_Group: null,
          Onboarding_Status: null,
          Date_onboarded: null,
          Acct_Restricted: null,
          Business_Use: null,
          Customer_Id: null,
          Customer_Name: null,
          Financial_Id: null,
          Aws_credits: null,
          WBS_code: null,
          IWO_code: null,
          Request_Type: null,
          Saas: null,
          MFA: 'Vault0',
          Root_Credential_Store: 'Vault0',
          Specific_Location: null,
          Specific_Region: null,
          Tmp_Cust_Name: null,
          AWS_Req_Type: null,
          AWS_Support_Type: null,
          Master_Id: null,
          MP_ID: null,
          AcctSecurity_Id: null,
          Unique_Agreement_Id: null,
          Acct_Exp_ID: null,
          Registration_Id: null,
          Account_Owners: [],
          CloudCheckr_users: [],
          IAM_Users: [],
          Notification_List: [],
          Financial_Owner: [],
          Invoice_DL: []
        },
        loadingChangeLog: false,
        changeLogs: [],
        changeLogHeaders: [
          {
            sortable: true,
            text: 'ID',
            value: 'Log_Id',
            align: 'left'
          },
          {
            sortable: true,
            text: 'Action',
            value: 'Action',
            align: 'left'
          },
          {
            sortable: false,
            text: 'User',
            value: 'User',
            align: 'left'
          },
          {
            sortable: true,
            text: 'Change From',
            value: 'Change_From',
            align: 'left'
          },
          {
            sortable: false,
            text: 'Change To',
            value: 'Change_To',
            align: 'left'
          },
          {
            sortable: true,
            text: 'Created At',
            value: 'Create_Date',
            align: 'left'
          }
        ]
      }
    },
    setLoadingUpdate: (state, loading) => {
      state.updateAccount.saving = loading
    },
    setAlertMessage: (state, data) => {
      state.updateAccount = {
        ...state.updateAccount,
        showAlertResponse: true,
        ...data
      }
    },
    updateOnboardingRecordList: (state, record) => {
  
      console.log(':::::::::::::: testings :::::::::::::::::')
      console.log(record)
      let recordIndex = state.onboardingAccounts.findIndex(account => account.Onboarding_Id === record.Onboarding_Id)
      if (recordIndex !== -1) {
        
        console.log(record.Onboarding_Id)
        state.onboardingAccounts.splice(recordIndex, 1, { ...state.onboardingAccounts[recordIndex], ...record })
      }
    },
    
    setLoadingOnboardingLogs: (state, loading) => {
      state.updateAccount.loadingChangeLog = loading
    },
    setOnboardingChangeLog: (state, logs) => {
      state.updateAccount.changeLogs = logs
    },
    setAccountIdAvailabilityMessage (state, data) {
      if (data.type === 'success') {
        state.updateAccount = {
          ...state.updateAccount,
          accountIdExist: true,
          accountIdExistSuccess: true,
          accountIdExistSuccessMessages: [data.message],
          accountIdExistError: false,
          accountIdExistErrorMessages: [],
          isAccountIdExist: data.isExist
        }
      } else {
        state.updateAccount = {
          ...state.updateAccount,
          accountIdExist: false,
          accountIdExistSuccess: false,
          accountIdExistSuccessMessages: [],
          accountIdExistError: true,
          accountIdExistErrorMessages: [data.message],
          isAccountIdExist: data.isExist
        }
        state.existingOnboardingAccount = {
          AcctSecurity_Id: data.record.AcctSecurity_Id, 
          Acct_Exp_Id:data.record.Acct_Exp_Id, 
          Acct_ID: data.record.Acct_ID, 
          Financial_Id: data.record.Financial_Id, 
          Onboarding_Id: data.record.Onboarding_Id, 
          Unique_Agreement_Id: data.record.Unique_Agreement_Id
        }
      }
    },
  
    setAccountIdExistLoading (state, loading) {
    
      if (loading) {
        state.updateAccount = {
          ...state.updateAccount,
          accountIdExist: false,
          accountIdExistLoading: loading,
          accountIdExistError: false,
          accountIdExistErrorMessages: [],
          accountIdExistSuccess: false,
          accountIdExistSuccessMessages: []
        }
      } else {
        state.updateAccount = {
          ...state.updateAccount,
          accountIdExistLoading: loading
        }
      }
    },
  
    setOpportunityNumberAvailabilityMessage (state, data) {
      if (data.type === 'success') {
        state.updateAccount = {
          ...state.updateAccount,
          opportunityNumberExist: true,
          opportunityNumberExistSuccess: true,
          opportunityNumberExistSuccessMessages: [data.message],
          opportunityNumberExistError: false,
          opportunityNumberExistErrorMessages: [],
          isOpportunityNumberExist: data.isExist
        }
      } else {
        state.updateAccount = {
          ...state.updateAccount,
          opportunityNumberExist: false,
          opportunityNumberExistSuccess: false,
          opportunityNumberExistSuccessMessages: [],
          opportunityNumberExistError: true,
          opportunityNumberExistErrorMessages: [data.message],
          isOpportunityNumberExist: data.isExist
        }
        // state.existingOnboardingAccount = {
        //   AcctSecurity_Id: data.record.AcctSecurity_Id, 
        //   Acct_Exp_Id:data.record.Acct_Exp_Id, 
        //   Acct_ID: data.record.Acct_ID, 
        //   Financial_Id: data.record.Financial_Id, 
        //   Onboarding_Id: data.record.Onboarding_Id, 
        //   Unique_Agreement_Id: data.record.Unique_Agreement_Id
        // }
      }
    },
  
    setOpportunityNumberExistLoading (state, loading) {
    
      if (loading) {
        state.updateAccount = {
          ...state.updateAccount,
          opportunityNumberExist: false,
          opportunityNumberExistLoading: loading,
          opportunityNumberExistError: false,
          opportunityNumberExistErrorMessages: [],
          opportunityNumberExistSuccess: false,
          opportunityNumberExistSuccessMessages: []
        }
      } else {
        state.updateAccount = {
          ...state.updateAccount,
          opportunityNumberExistLoading: loading
        }
      }
    },
  
  
    setExistingOnboardingAccount: (state, account) => {
      state.existingOnboardingAccount = {
        AcctSecurity_Id: account.AcctSecurity_Id, 
        Acct_Exp_Id: account.Acct_Exp_Id, 
        Acct_ID: account.Acct_ID, 
        Financial_Id: account.Financial_Id, 
        Onboarding_Id: account.Onboarding_Id, 
        Unique_Agreement_Id: account.Unique_Agreement_Id
      }
    },
    setOnboardingStatus(state, status){
      state.existingOnboardingAccount.Onboarding_Status = status
    },
  
    setCreateAccountLoading(state, loading) {
      state.createAccount = {
        ...state.createAccount,
        creating: loading
      }
    },
  
    setDeliveredAccount(state, accountId){
      state.updateAccount.record = {
        ...state.updateAccount.record,
        Acct_ID: accountId,
        Onboarding_Status: 'Account Configuration in Progress',
  
      }
    },
  
    resetCreateAccount(state){
      state.createAccount = {
        showDialog: false,
        creating: false,
        fields: {
          external_id: null
        }
      }
    }
  
  
  }
  